module.exports = __webpack_public_path__ + "static-portal/img/pallet-yyms.5a2f146.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pallet-yyms.gif
// module id = 6/sS
// module chunks = 4